import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const PageArticle = lazy(() => import('./views/article'));

const Article = () => {
  return (
    <Routes>
      <Route path="/" element={<PageArticle />} />
    </Routes>
  );
};

export default Article;
